import { requestFromServer } from "./api-client";

const PlantQuotas = {
  add: async (plantQuotaConfig) => {
   return requestFromServer(`v1/Plant_Quotas/add`, "POST", plantQuotaConfig);
  },
  update: async (plantQuotaConfigUpdated) => {
    return requestFromServer(
      `v1/Plant_Quotas/update/${plantQuotaConfigUpdated.id}`,
      "PUT",
      plantQuotaConfigUpdated
    );
  },
  list: async (idBranch, date, idPlant) => {
    return requestFromServer(
      `v1/Plant_Quotas/list/${idBranch}/${date}/0/${idPlant ? idPlant : 0}`//Revisar esta condição para pesquisar com array de ids (usar POST)
    );
  },
  delete: async (id) => {
    return requestFromServer(`v1/Plant_Quotas/delete/${id}`, "delete");
  },
};

export default PlantQuotas;
